import { Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useQuery } from "@tanstack/react-query";
import { useTranslate } from "../../../hooks/useTranslate";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useStudents } from "../../../context/students";
import TaskCard from "../../../components/TaskCard";
import Students1 from "../../../assets/images/images/students3.jpg";
import Students2 from "../../../assets/images/images/students4.jpg";
import useStatuses from "../../../context/status/useStatuses";
import { ISAMS_LINK } from "../../../services/isamsConfig";
import axiosManager from "../../../services/axiosManager";

const SupportingLearning = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();

    const { activeStudentId } = useStudents();
    const { studentIsamsId } = useStatuses();

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("supportingLearning.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("supportingLearning.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("supportingLearning.subtitle")}
                    </Typography>
                    <Typography variant="h1" component="h2" className="mt-8 text-white">
                        {t("common.quickLinks")}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5, lg: 4 }}>
                    <div className="images-head-section">
                        <div className="img-head-section">
                            <img alt="students-1" src={Students1} />
                        </div>
                        <div className="img-head-section">
                            <img alt="students-2" src={Students2} />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
            <Grid2 container spacing={4} className="mt-4">
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("supportingLearning.itp")}>
                        <Typography variant="body1" component="div">
                            {t("supportingLearning.itpText")}
                        </Typography>
                        <Button
                            href={`https://finance.kingsinterhigh.co.uk/send/validation/?isamsid=${studentIsamsId}`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("supportingLearning.contributionLevels")}>
                        <Typography variant="body1" component="div">
                            {t("supportingLearning.contributionLevelsText")}
                        </Typography>
                        <Button
                            href={`https://finance.kingsinterhigh.co.uk/cl/?kihid=${studentIsamsId}`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("supportingLearning.enrolAdditionalServices")}>
                        <Typography variant="body1" component="div">
                            {t("supportingLearning.enrolAdditionalServicesText")}
                        </Typography>
                        <Button
                            href={`https://finance.kingsinterhigh.co.uk/send/bookings/?kihid=${studentIsamsId}`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("supportingLearning.libraryLearner")}>
                        <Typography variant="body1" components="div">
                            {t("supportingLearning.libraryLearnerText")}
                        </Typography>
                        <Button
                            href={`https://finance.kingsinterhigh.co.uk/ll/?kihid=${studentIsamsId}`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("supportingLearning.bookAssessment")}>
                        <Typography variant="body1" component="div">
                            {t("supportingLearning.bookAssessmentText")}
                        </Typography>
                        <Button
                            onClick={() => navigate(`/supporting-learning/assessments/${activeStudentId}`)}
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default SupportingLearning;
